module.exports = __webpack_public_path__ + "static/media/sabah_logo.115036b2.svg";